import React from 'react';
import { Card, Group, Title } from '@mantine/core';
import { BadgeActive } from '../BadgeActive';
import { ISystemTypeBase } from '../../../api-client';

export interface ICardTypeBaseProps {
  entity: ISystemTypeBase;
}

const CardTypeBase = ({ entity }: ICardTypeBaseProps) => {
  return (
    <Card shadow="sm" p="xs" radius="md" m="sm" withBorder key={entity.code}>
      <Group position="apart" mt="md" mb="xs">
        <div>
          <Title order={6}>
            {entity.nameFr} ({entity.code})
          </Title>
          <BadgeActive active={entity.active} />
        </div>
      </Group>
    </Card>
  );
};

export default CardTypeBase;
